import { Button, MuiModal, Text } from '@pinchenterprisesnpm/friday-ui'
import { BoldSpan } from '@src/components/common/style'
import { InfoSubsection } from '@src/features/shift-post-v2/steps/shift-details-step/components/position-name-section/components/info-subsection/info-subsection'
import { getPhysicalReqContent } from '@src/features/shift-post-v2/steps/shift-details-step/components/position-name-section/components/info-subsection/info-subsection.utils'
import { IPositionNameSectionFormValues } from '@src/features/shift-post-v2/steps/shift-details-step/components/position-name-section/position-name-section.types'
import { connect, FormikProps } from 'formik'

const { Header, Content, Footer } = MuiModal

interface IFullDescriptionModalProps {
  isOpen: boolean
  closeModal: () => void
  infoContent: {
    title: string
    content: string | undefined
    required: boolean
  }[]
  physicalRequirementsStrings: {
    title: string
    content: string
  }[]
  formik?: FormikProps<IPositionNameSectionFormValues>
}

export const FullDescriptionModal = connect<IFullDescriptionModalProps>(
  ({
    isOpen,
    closeModal,
    infoContent,
    physicalRequirementsStrings,
    formik,
  }) => {
    const {
      values: { gig_type },
    } = formik

    return (
      <MuiModal isOpen={isOpen} closeModal={closeModal} fullWidth maxWidth="md">
        <Header title="Shift Details" />

        <Content>
          <Text fontSize="h2" mt="xs">
            <BoldSpan>Position Name:</BoldSpan> {gig_type ?? '/'}
          </Text>

          {infoContent.map(content => (
            <InfoSubsection
              key={content.title}
              content={content.content}
              title={content.title}
              showFullDescription={true}
              isRequired={content.required}
            />
          ))}

          <InfoSubsection
            title="Physical Requirements"
            content={getPhysicalReqContent(physicalRequirementsStrings)}
            showFullDescription={true}
          />
        </Content>

        <Footer>
          <Button onClick={closeModal}>Okay</Button>
        </Footer>
      </MuiModal>
    )
  },
)
